import { FiArrowUp } from "react-icons/fi";
import useScrollPosition from "@hooks/useScrollPosition";
import scrollToTop from "@utils/scrollToTop";
import "./ScrollToTop.scss";

function ScrollToTop() {
  const { isMiddleTopOffset } = useScrollPosition();

  return (
    <button
      type="button"
      className={`scroll-to-top ${isMiddleTopOffset ? "is-visible" : ""}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <FiArrowUp aria-hidden="true" />
    </button>
  );
}

export default ScrollToTop;
